module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/toilet-8bbfec6d6dd5d02e6e80316594c13e1f.svg";